const Card = ({id, className, children}) => {
    return (
    <div id = {id} className={`card ${className}`}>
        {children}
    </div>
    )
}

export default Card